<div class="hero" [class]="cssClasses()">
  <img
    class="hero__logo"
    [src]="logoUrl()"
    [alt]="logoAltText()"
    [attr.height]="logoHeight()"
    [attr.width]="logoWidth()"
  />
</div>
